import { JuneauConfig } from "Data/JuneauConfig";
import { LondonConfig } from "Data/LondonConfig";
import { NewOrleansConfig } from "Data/NewOrleansConfig";
import { ParisConfig } from "Data/ParisConfig";
import { RioConfig } from "Data/RioConfig";
import type { AssetFactoryPattern } from "html-living-framework";
import type { ILocationConfig } from "Interfaces/ILocationConfig";
import {DelhiConfig} from "./DelhiConfig";

// type LocationConfig = typeof GameConfig.locations[LocationID];

export type LocationID = "juneau" | "paris" | "rio" | "neworleans" | "london" | "delhi";
export type ItemID = string;
export type PayoffID = string;
export type HidingSpotID = string;

export const LocationIDs = ["juneau", "paris", "rio", "neworleans", "london", "delhi"] as LocationID[];

// https://stackoverflow.com/a/52221718
// type AllUnionMemberKeys<T> = T extends any ? keyof T : never;

export const GameConfig: {
  locations: Record<LocationID, ILocationConfig>,
  spritesheets: Record<LocationID, string[]>,
  spritesheet_factory: Record<LocationID, {
    [resolutionSuffix: string]: AssetFactoryPattern;
  }>,
} = {
  locations: {
    juneau: JuneauConfig,
    paris: ParisConfig,
    rio: RioConfig,
    neworleans: NewOrleansConfig,
    london: LondonConfig,
    delhi: DelhiConfig,
  },
  spritesheets: {
    juneau: ["juneau-1", "juneau-2", "juneau-3", "juneau-4"],
    paris: ["paris-1", "paris-2", "paris-3", "paris-4"],
    rio: ["rio-1", "rio-2", "rio-3", "rio-4", "rio-5", "rio-6"],
    neworleans: ["neworleans-1", "neworleans-2", "neworleans-3", "neworleans-4"],
    london: ["london-1", "london-2", "london-3", "london-4"],
    delhi: ["delhi-1", "delhi-2", "delhi-3", "delhi-4"],
  },
  spritesheet_factory: {
    juneau: {"@1x": 1, "@2x": [1, 4]},
    paris: {"@1x": 1, "@2x": [1, 4]},
    rio: {"@1x": [1, 2], "@2x": [1, 6]},
    neworleans: {"@1x": 1, "@2x": [1, 4]},
    london: {"@1x": 1, "@2x": [1, 4]},
    delhi: {"@1x": 1, "@2x": [1, 4]},
  },
};
